var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.375C10.5 3.86719 10.8828 4.25 11.375 4.25H14V9.9375C14 10.6758 13.3984 11.25 12.6875 11.25H7.4375C6.69922 11.25 6.125 10.6758 6.125 9.9375V2.0625C6.125 1.35156 6.69922 0.75 7.4375 0.75H10.5V3.375ZM11.375 0.75L14 3.375H11.375V0.75ZM5.25 10.375C5.25 11.3594 6.01562 12.125 7 12.125H7.875V13.4375C7.875 14.1758 7.27344 14.75 6.5625 14.75H1.3125C0.574219 14.75 0 14.1758 0 13.4375V5.5625C0 4.85156 0.574219 4.25 1.3125 4.25H5.25V10.375Z",
    fill: "#4C5E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCopy);
export default __webpack_public_path__ + "static/media/icons_copy.9617e052.svg";
export { ForwardRef as ReactComponent };